import React, { Fragment, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/pro-regular-svg-icons";
import { useCurrentUser } from "../../auth/authUtils";
import {
  hasError,
  firstError,
  validateEmail,
  validateEmailField,
} from "../../user-admin/userValidation";
import { isBlank } from "../../util/ext";
import { useRequestCollectionMarc } from "../../manage-organizations/organizationServices";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Link from "@material-ui/core/Link";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import LoadingIndicator from "../../components/LoadingIndicator";

const useStyles = makeStyles(theme => ({
  helperText: {
    top: 50,
  },
}));

const RequestCollectionMarc = ({ collectionId, showAlert }) => {
  const classes = useStyles();
  const user = useCurrentUser();

  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [email, setEmail] = useState("");
  useEffect(() => {
    if (user.username) {
      setEmail(user.username);
    }
  }, [user.username]);

  // Manage Email State
  const handleChangeEmail = event => {
    const value = event.target.value;
    setEmail(value);
  };

  const handleBlur = () => {
    setErrors(validateEmailField("emailAddress", email));
  };

  // Manage Request
  const requestCollectionMarc = useRequestCollectionMarc();
  const handleRequest = async () => {
    const error = validateEmail({ emailAddress: email });

    if (isBlank(error)) {
      await requestCollectionMarc.mutateAsync({
        data: {
          email: email,
          collectionIds: [collectionId],
        },
      });
      setOpen(false);
      showAlert("success", ["Email sent"]);
    }
  };
  return (
    <Fragment>
      <Button
        onClick={() => setOpen(true)}
        startIcon={<FontAwesomeIcon icon={faEnvelope} />}
      >
        Request Collection MARC Record
      </Button>

      <Dialog open={open}>
        <DialogTitle>Request Collection MARC Record</DialogTitle>

        <DialogContent>
          {requestCollectionMarc.isLoading && <LoadingIndicator transparent />}
          <TextField
            id="email"
            required
            fullWidth
            variant="outlined"
            label="Email"
            placeholder="Email"
            value={email}
            onChange={handleChangeEmail}
            onBlur={handleBlur}
            error={hasError(errors, "emailAddress")}
            helperText={firstError(errors, "emailAddress")}
            FormHelperTextProps={{
              classes: {
                root: classes.helperText,
              },
            }}
          />

          <Typography style={{ paddingTop: isBlank(errors) ? 20 : 30 }}>
            You will receive an email with a link to download your generated
            MARC record. If you have any issues or questions, please contact{" "}
            <Link href="mailto:support@biblioboard.com" target="_blank">
              support@biblioboard.com
            </Link>
            .
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleRequest} variant="contained" color="primary">
            Request
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default RequestCollectionMarc;
